export function criarFormatador () {
    return new Intl.NumberFormat('pt-br', { style: 'currency', currency: 'BRL' });
}
